export default __webpack_public_path__ + "static/media/arbitrum-disable.fdc2d9ba.svg";